import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MasterDataEditService } from '../../../../../api/master-data-edit.service';
import { AffectingSubBrandData } from '../../../../../shared/models/product.model';

@Component({
  selector: 'app-rename-sub-brand',
  templateUrl: './rename-sub-brand.component.html',
})
export class RenameSubBrandComponent implements OnInit {
  @ViewChild('existingSubBrandNameGrid') existingSubBrandNameGrid: DxDataGridComponent;

  public affectedEditSubBrandNameData: AffectingSubBrandData[] = [];
  public existingEditSubBrandNameData: AffectingSubBrandData[] = [];

  @Input() selectedEditSubBrandOldName: string;
  @Input() selectedEditSubBrandNewName: string;
  @Input() subBrandId;

  private _destroyed$ = new Subject();

  constructor(private masterDataEditService: MasterDataEditService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
	this.masterDataEditService.getAffectingSubBrandData(this.selectedEditSubBrandOldName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingSubBrandData[]) => {
		this.affectedEditSubBrandNameData = res;
		});

	this.masterDataEditService.getExistingSubBrandData(this.selectedEditSubBrandNewName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingSubBrandData[]) => {
		this.existingEditSubBrandNameData = res;
		});
  }

  rename() {
	this.activeModal.close('save');
  }

  customizeSubBrandId(cellInfo) {
	const idStr = 'SBR_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  valueChanged(event) {
	this.existingSubBrandNameGrid.instance.beginCustomLoading('Loading');
	this.masterDataEditService.getExistingSubBrandData(event.value)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingSubBrandData[]) => {
		this.existingEditSubBrandNameData = res;
		this.existingSubBrandNameGrid.instance.option('dataSource', res);
		this.existingSubBrandNameGrid.instance.endCustomLoading();
		});
  }

}
